/**
 * Account Mega Menu
 * 
 * This script is used to handle the account mega menu functionality.
 * It is used to display a mega menu for the manage account menu item on top navigation.
 * 
 * @type {Drupal.Behavior}
 * 
 * @param {Drupal.Context} context - The context of the current page.
 */
(function (Drupal, once) {
    'use strict';
  
    Drupal.behaviors.accountMegaMenu = {
      attach: function (context, settings) {
        once('account-mega-menu', '.account-mega-menu', context).forEach(function (megaMenu) {
            
            const navLinks = megaMenu.querySelectorAll('.account-mega-menu__nav-link');
            const panels = megaMenu.querySelectorAll('.account-mega-menu__panel');

            navLinks.forEach(function (link) {

              link.addEventListener('click', handlePersonaSwitch);
              
            });

            function handlePersonaSwitch(e) {

              e.preventDefault();
              const persona = this.dataset.persona;
    
              // Update active states
              navLinks.forEach(function (link) {
                link.classList.remove('active');
              });
              
              panels.forEach(function (panel) {
                panel.classList.remove('active');
              });
              
              // Add active class to current link and panel
              this.classList.add('active');
              const targetPanel = megaMenu.querySelector('[data-panel="' + persona + '"]');
              if (targetPanel) {
                targetPanel.classList.add('active');
              }
            }
        });
      }
    };
  })(Drupal, once);